module.exports = __webpack_public_path__ + "img/logo-plasvale.7600da8e.png";